import Logo from './Logo';

export default Logo ;



// WEBPACK FOOTER //
// ./src/components/Header/Logo/index.js